import React, { useEffect, useState } from 'react'
import useSWR from 'swr'
import { withTranslation } from 'react-i18next'
import { useFormContext } from 'react-hook-form'
import { apiRequest } from 'store/Misc/apiRequest'
import { useSelector } from 'react-redux'

export default withTranslation()(function Impressions({ t }) {
  const { data: balance } = useSWR('accounts/balances')
  // console.log(balance ? balance.data[3].balance : 0);
  const [targetCount, setTargetCount] = useState({
    reach: 0,
    audience: 0,
    impressions: 0
  })

  const { impression } = useSelector(state => state.misc)

  const { watch } = useFormContext()
  const
    // gender = watch('gender'),
    // min_age = watch('min_age'),
    // max_age = watch('max_age'),
    // education = watch('education'),
    // profession = watch('profession'),
    budget = watch('budget')

  useEffect(() => {

    async function getPotentialReach() {
      try {
        const result = await apiRequest({
          method: 'get',
          url: 'promos/campaigns/potential-count',
        })
        console.log('Potential Reach results', result.data)
        setTargetCount(targetCount => ({ ...targetCount, reach: result.data }))
      } catch (e) {
        console.log(e);
      }
    }
    getPotentialReach()
  }, []);
  useEffect(() => {
    async function getTargetAudience() {
      try {
        const result = await apiRequest({
          method: 'post',
          url: 'promos/campaigns/target-count',
          // payload: {gender, min_age, max_age, education, profession}
        })
        console.log('Target counnt results', result)
        setTargetCount(targetCount => ({ ...targetCount, audience: result.data }))
      } catch (e) {
        console.log(e);
      }
    }
    getTargetAudience()
  }, []);
  //  async function getImpressions() {
  //   try {
  //     const result = await apiRequest({
  //       method: 'post',
  //       url: 'promos/campaigns/get-impressions-by-budget',
  //       payload: { budget }
  //     })
  //     setTargetCount(targetCount => ({ ...targetCount, impressions: result.data }))
  //   } catch (e) {

  //   }
  // }
  useEffect(() => {
    Promise.resolve(impression).then(impression => setTargetCount(targetCount => ({ ...targetCount, impressions: impression })))
  }, [impression]);
  return (
    <div className="bg-white rounded-xl divide-y lg:h-[380px] w-full order-1 lg:order-2 shadow-lg">
      <ul className="w-full p-5">
        <li className="mb-5">
          <label className="text-dark-blue text-lg font-bold">{t('promo.form.audience')}</label>
        </li>
        <li className="text-secondary font-medium flex w-full justify-between">
          <label>{t('promo.form.reach')}</label>
          <span className="font-bold">{targetCount?.reach}</span>
        </li>
        <li className="text-secondary font-medium py-3 flex w-full justify-between">
          <label>{t('promo.form.audience')}</label>
          <span className="font-bold">{targetCount?.audience}</span>
        </li>
        <li className="text-secondary font-medium flex w-full justify-between">
          <label>{t('promo.form.impression')}</label>
          <span className="font-bold">{targetCount?.impressions}</span>
        </li>
      </ul>

      <ul className="w-full p-5">
        <li className="mb-5">
          <label className="text-dark-blue text-lg font-bold">{t('promo.form.budget')}</label>
        </li>
        <li className="text-secondary font-medium flex w-full justify-between">
          <label>{t('promo.form.available')}</label>
          <span className="font-bold">{balance ? balance?.data[3]?.balance : 0} </span>
        </li>
        <li className="text-secondary font-medium py-3 flex w-full justify-between">
          <label>{t('promo.form.campaign')}</label>
          <span className="font-bold">{budget && balance?.data[3]?.balance - budget >= 0 ? budget : 0}</span>
        </li>
        <li className="text-secondary font-medium flex w-full justify-between">
          <label>{t('promo.form.balance')}</label>
          <span className="font-bold">{balance && balance?.data[3]?.balance - budget >= 0 ? balance?.data[3]?.balance - budget : 0}</span>
        </li>
      </ul>
    </div>
  )
})
